import { Box } from '@chakra-ui/react';
import { Text } from 'components/ui';

type Props = {
  header?: string | null;
};

/**
 * The affiliate's cost claim, full bleed across the top of the booking card.
 *
 * Header only. The body belongs under "What will this cost?", and the design
 * clears it here so the same sentence does not appear twice on one screen.
 * Renders nothing without a header, which is the self-pay case.
 */
export const CostBand = ({ header }: Props) => {
  if (!header?.trim()) return null;

  return (
    <Box
      bg={'blue.100'}
      color={'blue.500'}
      mx={'-22px'}
      mt={'-22px'}
      mb={'4px'}
      px={'16px'}
      py={'14px'}
      roundedTop={'panel'}
      textAlign={'center'}
    >
      <Text as={'span'} color={'blue.500'} fontSize={'13.5px'} fontWeight={600}>
        {header}
      </Text>
    </Box>
  );
};
